import { useQuery } from "@tanstack/react-query";
import { Layout } from "providers/Layout";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { Plus, Users02 } from "untitledui-js-base";
import { useState } from "react";
import { BreadCrumbs } from "shared/components/BreadCrumbs";
import { instance } from "api/apiBase";
import { InviteNewMemberModal } from "./components/InviteNewMemberModal";
import { TeamMember } from "./components/TeamMember";

export const TeamView = () => {
  const { data: usersData } = useQuery({
    queryKey: ["GET_TEAM_MEMBERS"],
    queryFn: () =>
      instance
        .get("/portal/v1/users", {
          params: {
            page: "1",
            per_page: "50",
            order_direction: "desc"
          }
        })
        .then((d) => d.data?.items || [])
  });

  const [showInviteModal, setShowInviteModal] = useState(false);

  return (
    <Layout
      sectionClassName={
        usersData?.length ? "" : "flex justify-center items-center"
      }
      header={
        <>
          <div className="flex items-center justify-between border-b border-alpha-40 px-3 md:px-6 pb-3">
            <BreadCrumbs
              crumbs={[
                {
                  title: "Settings",
                  href: "/settings"
                },
                {
                  title: "Team",
                  href: "/settings/team"
                }
              ]}
            />
          </div>
          <div className="flex items-center justify-between p-6 pb-3">
            <h1 className="text-xl font-bold text-content-1000">Team</h1>
            <Button
              variant={ButtonVariant.PRIMARY}
              size={ButtonSize.SM}
              Icon={Plus}
              onClick={() => setShowInviteModal(true)}
            >
              Invite a New Member
            </Button>
          </div>
        </>
      }
    >
      {usersData?.length ? (
        <div className="rounded-lg border border-alpha-100 bg-background-1000 p-6 lg:max-w-[648px]">
          {usersData.map((user, idx) => {
            return (
              <div key={user.id}>
                <TeamMember user={user} />
                {idx === usersData.length - 1 ? null : (
                  <div className="my-6 border-b border-alpha-40" />
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center">
          <div className="mb-6 flex items-center justify-center rounded-full bg-alpha-40 p-7">
            <Users02 size="40" className="stroke-content-400" />
          </div>
          <p className="mb-2 text-base font-bold text-content-500">
            Team members will appear here
          </p>
          <p className="mb-6 text-sm font-medium text-content-300">
            You can invite team members to access your Boom system{" "}
          </p>
          <Button
            variant={ButtonVariant.PRIMARY}
            size={ButtonSize.SM}
            onClick={() => setShowInviteModal(true)}
          >
            Invite a New Member
          </Button>
        </div>
      )}
      <InviteNewMemberModal
        opened={showInviteModal}
        onClose={() => setShowInviteModal(false)}
      />
    </Layout>
  );
};
